<template>
    <multiselect
        @update:model-value="updateValue"
        :model-value="modelValueSelect"
        :options="options"
        :show-labels="false"
        :placeholder="placeholder"
        :multiple="false"
        :searchable="false"
        :allow-empty="allowEmpty"
        :max-height="maxHeight"
        :open-direction="openDirection"
        track-by="value" 
        label="label"></multiselect>
</template>

<script setup>
import { computed } from 'vue';

import Multiselect from 'vue-multiselect';

const props = defineProps({
    modelValue: {
        type: [String, Number, Array, Object],
        default: null,
    },
    options: {
        type: [Array, Object],
        default: () => []
    },
    placeholder: {
        type: String,
        default: null
    },
    allowEmpty: {
        type: Boolean,
        default: true
    },
    maxHeight: {
        type: Number,
        default: 300
    },
    openDirection: {
        type: String,
        default: 'auto'
    }
});

const emit = defineEmits(['update:model-value']);

const modelValueSelect = computed(() => {
    const selectValue = props.options.filter(o => props.modelValue === o.value);

    if (selectValue === null || selectValue.length === 0) {
        null;
    }

    return selectValue;
});

const updateValue = (value) => {
    emit('update:model-value', value);
};

</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>